module.exports = __webpack_public_path__ + "img/Roboto-Bold.27a7a19.svg";